module.exports = __webpack_public_path__ + "resources/img/img_intro_certi8.7420c0c0f47fe822c46cabcf2ab15bb9.png";